import axios from 'axios';

const url = process.env.REACT_APP_API_URL;
const adminRequest = axios.create({
  baseURL: `${url}/admin`,
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      return JSON.parse(response).data;
    }
    return null;
  }],
});

export default adminRequest;
